module.exports = __webpack_public_path__ + "static/media/Expired.6e7090f0.svg";